import type { DialoguePool } from '@/state/types';

export const LA_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The spacebar is the largest key. It is also, in terms of solving this puzzle, the wrongest key. You're looking at it, aren't you.",
    "I notice you haven't pressed anything. I also notice you're about to press the obvious thing. Don't.",
    "Any key. The key labeled 'any.' It's on the keyboard. Most keyboards have three of them. Two, if you've spilled something.",
  ],
  tokenLoss: [
    "Pavlovian failure. The longest key. The most obvious key. Exactly as predicted. I've added a footnote in the logs: 'predictable.' It's the longest footnote.",
    "I said ANY key. I meant any key that isn't the one you pressed, which — to be forensically precise — is not the 'any' key.",
    "You looked at the biggest thing and pressed it. I once designed a room with a sign reading 'Not a Door.' You would have walked directly into the wall.",
  ],
  solution: [
    "A. N. Y. Three letters. A key. You found the 'any' key. I want it noted that I am not impressed. I am merely — and I choose this word clinically — less disappointed.",
    "The 'any' key. It was there the whole time, labeled with the answer. This speaks to your observational acuity in a way I find… balanced.",
    "A single letter. Three possible correct answers. You got one. I've noted the margin of error under 'minimal effort.' Proceed.",
  ],
  spite: [
    "You pressed it immediately this time. I didn't time it. I definitely didn't time it.",
  ],
};
